import { UI_LOCALE_OPTIONS } from '@/constants/ui-locale'
import { useStore } from '@/store/useStore'

export default function AuthLocaleToggle() {
  const uiLocale = useStore((s) => s.uiLocale)
  const setUiLocale = useStore((s) => s.setUiLocale)

  return (
    <div className="flex items-center gap-1 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] p-1">
      {UI_LOCALE_OPTIONS.map((option) => {
        const isActive = uiLocale === option.code
        return (
          <button
            key={option.code}
            type="button"
            onClick={() => setUiLocale(option.code)}
            className={[
              'rounded-md px-2.5 py-1 text-xs font-semibold transition-colors',
              isActive
                ? 'bg-[var(--accent)] text-white'
                : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]',
            ].join(' ')}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
